import React, { Component, Fragment } from 'react';
import { Country } from '~/Api/Country';
import { Product } from '~/Api/Product';
import * as SkMaxPriceApi from '~/Api/User/ProductGroup/SkMaxPrice';

import Header from './Header/Header';
import Row, { EmptyRow, OnChangeListener, OnSelectListener, Values } from './Row';

export interface ProductRow {
	country: Country;
	product: SkMaxPriceApi.Product | null;
	usedForCalculation: boolean;
}

export type ProductValues = Values;

interface Props {
	disableSelection: boolean;
	rows: ProductRow[];
	productValues: { [key in string]: Values };
	detailLink(product: { id: string }): { pathname: string; search: string };
	highlightProductId: string | null;
	lastSelectedProductId: string | null;
	historicData: boolean;
	referencePackageSize: number | null;
	showReferenceDataSource: boolean;
	onChange: OnChangeListener;
	onSelect: OnSelectListener;
	onSave(): void;
	checkedRows: Product[];
	checkRow(product: Product, checked: boolean): void;
}

export default class ProductsTable extends Component<Props> {
	static defaultProps = {
		disableSelection: false,
		showReferenceDataSource: false,
		highlightProductId: null,
		lastSelectedProductId: null,
	};

	render() {
		const { rows } = this.props;

		return (
			<Fragment>
				<Header />
				{rows.map(({ product, country, usedForCalculation }) =>
					product !== null ? (
						this.renderRow(product, usedForCalculation)
					) : (
						<EmptyRow country={country} key={country.alpha2} />
					)
				)}
			</Fragment>
		);
	}

	renderRow(skMaxPriceProduct: SkMaxPriceApi.Product, usedForCalculation: boolean) {
		const {
			checkRow,
			productValues,
			highlightProductId,
			lastSelectedProductId,
			historicData,
			referencePackageSize,
			showReferenceDataSource,
			disableSelection,
			detailLink,
			onChange,
			onSelect,
			onSave,
		} = this.props;
		const { product } = skMaxPriceProduct;
		const checked = this.props.checkedRows?.some((row) => row.id === product.id);

		return (
			<Row
				detailLink={detailLink}
				disableSelection={disableSelection}
				highlightProduct={highlightProductId === product.id}
				historicData={historicData}
				checked={checked}
				checkRow={(value) => checkRow(product, value)}
				key={product.id}
				lastSelectedProduct={lastSelectedProductId === product.id}
				referencePackageSize={referencePackageSize}
				showReferenceDataSource={showReferenceDataSource}
				skMaxPriceProduct={skMaxPriceProduct}
				usedForCalculation={usedForCalculation}
				values={productValues[product.id]}
				onChange={onChange}
				onSave={onSave}
				onSelect={onSelect}
			/>
		);
	}
}
